module.exports = __webpack_public_path__ + "static/media/AWS-SysOps-Associate.ca86a922.png";